import request from "../request";
import { showCommonLoading, hideCommonLoading, showTips } from "../prompt/main";
import { weixinPay, appIosPay, appPay } from "./buyFun";
import publicVar from "../publicData/global_variable";

/**
 * 请求海报
 * @param {object} paramsObj
 * url: 请求的 url，
 * data: 请求的参数
 * success: 成功回调
 * fail: 失败回调 
 * noNeedLoading: 不需要显示“海报生成中”
 */
const getPosterAjax = (paramsObj) => {
    const { url, data, success, fail, noNeedLoading } = paramsObj;

    request(url, data, { "method": "GET" })
        .then(res => res.json())
        .then(function (response) {
            if (response.code === 200) {
                if (showCommonLoading && !noNeedLoading) {
                    showCommonLoading("海报生成中");
                }

                let tryNum = 0;
                let tryImg = function () {
                    //判断一下图片是否存在
                    var ImgObj = new Image();
                    ImgObj.src = response.data && response.data.returnUrl ? response.data.returnUrl : "";
                    ImgObj.onload = function () {
                        //检查是否安装了微信
                        if (hideCommonLoading) {
                            hideCommonLoading();
                        }
                        if (success && typeof success === "function") {
                            success(response);
                        }
                    }
                    ImgObj.onerror = function () {
                        tryNum++;
                        if (tryNum < 100) {
                            setTimeout(() => {
                                tryImg();
                            }, 100);
                        } else {
                            if (hideCommonLoading) {
                                hideCommonLoading();
                            }
                            showTips("生成图片有误，请点击重试", -1, () => {
                                getPosterAjax(paramsObj);
                            });

                            if (fail && typeof fail === "function") {
                                fail(response);
                            }
                        }
                    }
                }
                tryImg();
            } else {
                if (fail && typeof fail === "function") {
                    fail(response);
                }
            }
        })
}


/**
 * 调用 app 的方法
 * @param {object} paramsObj
 * url: 请求的 url，
 * data: 请求的参数
 * success: 成功回调
 * fail: 失败回调 
 */

const callApp = (paramsObj) => {
    const { name, param } = paramsObj;

    if (name && typeof name === "string") {
        if (window[name]) {
            if (param) {
                window[name](param);
            } else {
                window[name]();
            }
        } else if (window.android && window.android[name]) {
            if (param) {
                window.android[name](param);
            } else {
                window.android[name]();
            }
        } else if (window.webkit && window.webkit.messageHandlers && this.ios8IntoVariable) {  // 已不支持 ios8
            this.ios8IntoVariable(name, param);
        }
    } else {
        console.log("error: name is not a string or not exist!");
    }
}

/**
 * 支付
 * @param {object} paramsObj
 * data: 支付请求的参数
 * success: 调用成功回调
 * fail: 调用失败回调 
 * paySuccess: 支付成功回调
 * payPending: 支付中
 * payFail: 支付失败回调
 * qrcodeCallback: 二维码支付的回调
 */

let bClickFlag = false;    // 限制点击购买时的一秒间隔
window.commonBuy = {};

const putaoBuy = (paramsObj) => {
    if (bClickFlag) {
        return;
    } else {
        bClickFlag = true;
        setTimeout(function () {
            bClickFlag = false;
        }, 1000);
    }

    if (publicVar.isWx) {
        weixinPay(paramsObj);          // weixin
    } else if (publicVar.isIos && publicVar.isApp) {
        appIosPay(paramsObj);      // ios app
    } else {
        appPay(paramsObj);     // 非 ios app （包括 huawei、oppo、weixin）
    }

    window.commonBuy.paySuccess = (paramsObj && paramsObj.paySuccess) ? paramsObj.paySuccess : null;
    window.commonBuy.payFail = (paramsObj && paramsObj.payFail) ? paramsObj.payFail : null;
    window.commonBuy.payPending = (paramsObj && paramsObj.payPending) ? paramsObj.payPending : null;
    window.commonBuy.qrcodeCallback = (paramsObj && paramsObj.qrcodeCallback) ? paramsObj.qrcodeCallback : null;
}

export { getPosterAjax, callApp, putaoBuy };


// WEBPACK FOOTER //
// ./src/lib/JSBridge/index.js